import React, { useEffect } from "react";
import { Col, Row } from "antd";
import "./timesheetdetails.css";
import enter1 from "../../../../assets/icons/enter1.png";
// import enter2x from '../../../../assets/icons/enter2x.png';
import exit1 from "../../../../assets/icons/exit1.png";
// import exit2x from '../../../../assets/icons/exit2x.png';
import moment from "moment";
import TimesheetListReducer from "../../../../redux/reducers/TimesheetReducer";

const TimesheetDetailsCard = (props) => {
  // function millisToMinutesAndSeconds(millis) {
  //     var minutes = Math.floor(millis / 60000);
  //     setBreakTime(breakTime);
  //     var seconds = ((millis % 60000) / 1000).toFixed(0);
  //     return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
  // }

  const setItems = () => {
    props.timesheetId(props._id);
    props.date(props.Date);
    props.start(moment(props.TimeLogs[0]).format("h:mm A"));
    props.end(
      moment(props.TimeLogs[props.TimeLogs.length - 1]).format("h:mm A")
    );
  };

  return (
    <div className="timesheet-details-card-parent" onClick={setItems}>
      <Col xs={24} lg={24} className="timesheet-date-time-parent-container">
        <Row>
          <Col xs={24} lg={3}>
            {/* <div className="timesheet-date">Friday, Feb 18</div> */}
            <div className="timesheet-date">{moment(props.Date).format('dddd, MMMM DD, YYYY')}</div>
          </Col>
          <Col xs={8} lg={4} className="timesheet-start-time-container">
            {/* <div className='timesheet-enter-icon-div'></div> */}
            <div className="timesheet-enter-icon">
              <img src={enter1} alt={"icon"} />
            </div>
            <span className="timesheet-start-time">
              {moment(props.TimeLogs[0]).format("h:mm A")}
            </span>
          </Col>
          <Col xs={8} lg={4} className="timesheet-end-time-container">
            {/* <div className='timesheet-exit-icon-div'></div> */}
            <div className={"timesheet-exit-icon"}>
              <img src={exit1} alt={"icon"} />
            </div>
            <span className="timesheet-end-time">
              {moment(props.TimeLogs[props.TimeLogs.length - 1]).format(
                "hh:mm a"
              )}
            </span>
          </Col>
          <Col xs={8} lg={13} className="timehseet-recorded-time-div">
            <div>
              <span className="timesheet-spent-time">
                {props.SpentTime + " hrs"}
              </span>{" "}
              <span className="timesheet-break-time">
                {" "}
                | {props.BreakTime + " hrs"}
              </span>
            </div>
          </Col>
        </Row>
      </Col>
      {props.Breaks?.map((items, index) => {
        return (
          <Col key={index} xs={24} lg={24} className="timesheet-recorded-details-div">
            <div className="timesheet-recorded-details">
              <div className="timesheet-recorded-break">Break</div>
              <div className="timesheet-break-start-time">
                {moment(items.startTime).format("hh:mm A")}
              </div>
              <div className="timesheet-time-separator">-</div>
              <div className="timesheet-break-end-time">
                {moment(items.stopTime).format("hh:mm A")}
              </div>
              <div className="timesheet-total-break">
                {Math.floor(items.breakTime / 60000) + " mins"}
              </div>
            </div>
          </Col>
        );
      })}
    </div>
  );
};
export default TimesheetDetailsCard;
